import Button from 'components/Button'
import LightBorderCard from 'components/Card/LightBorderCard'
import { useFormikContext } from 'formik'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type BorderRoomCardProps = {
  title?: string
  children?: ReactNode
  className?: string
  distinct?: boolean
}

const BorderRoomCard = ({
  children,
  className,
  distinct = true,
  title = 'Filters'
}: BorderRoomCardProps) => {
  const { t } = useTranslation()
  const formik = useFormikContext()

  return (
    <form className={className} onSubmit={formik.handleSubmit}>
      <LightBorderCard title={title}>
        {children}
        <Button
          style={{
            marginRight: '10px',
            borderRadius: '70px',
            boxShadow: '2px 2px 7px rgba(0, 0, 0, 0.25)'
          }}
          action="primary"
          type="submit"
        >
          {t('Apply')}
        </Button>
      </LightBorderCard>
    </form>
  )
}

export default styled(BorderRoomCard)``
